import { createSlice } from "@reduxjs/toolkit";

const newsSlice = createSlice({
  name: "news",
  initialState: {
    newsList: [],
    isFetching: false,
    isFetchingAll: false,
    isLoggedIn: false,
    newsDetail: [],
    error: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    getNews: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getNewsSuccess: (state, action) => {
      state.isFetching = false;
      state.newsList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getNewsFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getNewsByCategory: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getNewsByCategorySuccess: (state, action) => {
      state.isFetching = false;
      state.newsList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getNewsByCategoryFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getNewsDetail: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getNewsDetailSuccess: (state, action) => {
      state.isFetching = false;
      state.newsDetail = action.payload.data
      state.error = false;
    },
    getNewsDetailFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    addNews: (state) => {
      state.isFetching = true
      state.error = false
    },
    addNewsSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    addNewsFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    updateNews: (state) => {
      state.isFetching = true
      state.error = false
    },
    updateNewsSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    updateNewsFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    removeNews: (state) => {
      state.isFetching = true
      state.error = false
    },
    removeNewsSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    removeNewsFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
});

export const newsActions = newsSlice.actions;
export default newsSlice.reducer;
